import React from "react";

const ContactUsMapContainer = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 py-12 lg:py-16">
      {/* Background glow */}
      <div className="pointer-events-none absolute inset-0 opacity-40">
        <div className="absolute -left-24 top-10 h-72 w-72 rounded-full bg-[#064585]/40 blur-3xl" />
        <div className="absolute -right-24 bottom-10 h-72 w-72 rounded-full bg-[#5989C8]/30 blur-3xl" />
      </div>

      {/* Content Container */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <div className="text-center mb-8 md:mb-12" data-aos="fade-up">
          <p className="inline-flex items-center justify-center px-4 py-1 rounded-full bg-white/5 border border-white/10 text-xs sm:text-sm text-[#5989C8] font-medium backdrop-blur-md">
            Our Location
          </p>
          <h2 className="mt-4 text-2xl md:text-3xl lg:text-4xl font-bold text-white tracking-wide">
            Visit Web_Bocket Classes
          </h2>
          <p className="mt-3 text-sm md:text-base text-slate-300/90 max-w-2xl mx-auto">
            Find us easily on the map below — we’re always happy to guide you
            toward your learning journey!
          </p>
        </div>

        {/* Map Container */}
        <div
          className="relative rounded-2xl overflow-hidden border border-white/10 shadow-xl shadow-slate-950/40 backdrop-blur-md hover:shadow-[#064585]/30 transition-all duration-300"
          data-aos="zoom-in"
        >
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3743.130886432441!2d85.78234237469417!3d20.25340581395823!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a19098aa66063cd%3A0x55d0623fa712cd29!2sWeb_Bocket!5e0!3m2!1sen!2sin!4v1730462958198!5m2!1sen!2sin"
            width="100%"
            height="450"
            loading="lazy"
            allowFullScreen=""
            referrerPolicy="no-referrer-when-downgrade"
            className="rounded-2xl border-none"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default ContactUsMapContainer;
